import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { format } from '@/@core/utils/string';
import { anyTransform } from '../../utils/lang';
let CompanyOrderApi = class CompanyOrderApi {
    constructor(http, urls, boHelperService) {
        this.http = http;
        this.urls = urls;
        this.boHelperService = boHelperService;
        /**
         * 查询公司订单列表
         */
        this.getOrders = (company_id) => {
            const url = format(this.urls.getOrders, {
                company_id,
            });
            return this.http.get({
                url,
            });
        };
        this.getBehaviorOrders = (company_id) => {
            const url = format(this.urls.getBehaviorOrders, {
                company_id,
            });
            return this.http.get({
                url,
            });
        };
        /**
         * 查询订单详情
         */
        this.getOrderDetail = (order_id) => {
            const url = format(this.urls.getOrderDetail, {
                order_id,
            });
            return this.http.get({
                url,
            });
        };
        /**
         * 添加订单
         */
        this.postOrderAdd = (params) => {
            const url = this.urls.postOrderAdd;
            params = this.transformOrderParams(params);
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 编辑订单预检测
         */
        this.postOrderEditCheck = (params) => {
            const url = this.urls.postOrderEditCheck;
            params = this.transformOrderParams(params);
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 编辑订单
         */
        this.putOrderEdit = (params) => {
            const url = this.urls.putOrderEdit;
            params = this.transformOrderParams(params);
            return this.http.put({
                url,
                data: params,
            });
        };
        this.postOrderCheck = (params) => {
            const url = this.urls.postOrderCheck;
            params = this.transformOrderParams(params);
            return this.http.post({
                url,
                data: params,
            });
        };
        /**
         * 启用订单
         */
        this.patchOrderEnable = (order_id) => {
            const url = format(this.urls.patchOrderEnable, {
                order_id,
            });
            return this.http.patch({
                url,
            });
        };
        /**
         * 关闭订单
         */
        this.patchOrderDisable = (order_id) => {
            const url = format(this.urls.patchOrderDisable, {
                order_id,
            });
            return this.http.patch({
                url,
            });
        };
        /**
         * 删除Privilege合同
         */
        this.patchCompanyPrivilegeContractDelete = (privilege_contract_id) => {
            const url = format(this.urls.patchCompanyPrivilegeContractDelete, {
                privilege_contract_id,
            });
            return this.http.patch({
                url,
            });
        };
        /**
         * 删除订单下所有的容量合同
         */
        this.patchCompanyCapacityContractAllDelete = (order_id) => {
            const url = format(this.urls.patchCompanyCapacityContractAllDelete, {
                order_id,
            });
            return this.http.patch({
                url,
            });
        };
        /**
         * 判断合同号是否存在
         */
        this.getOrderContractExisted = (contractNumber) => {
            const url = this.urls.getOrderContractExisted;
            return this.http.get({
                url,
                params: {
                    contractNumber,
                },
            });
        };
    }
    transformOrderParams(params) {
        return anyTransform(params, (path, value) => {
            if (path === '.order_pojo.begin_at_value' ||
                path === '.company_privilege_details.[].company_privilege_contract_pojo.begin_at_value' ||
                path === '.company_capacity_details.[].company_capacity_contract_pojo.begin_at_value') {
                return this.boHelperService.serializeBeginDate(value);
            }
            else if (path === '.order_pojo.end_at_value' ||
                path === '.company_privilege_details.[].company_privilege_contract_pojo.end_at_value' ||
                path === '.company_capacity_details.[].company_capacity_contract_pojo.end_at_value') {
                return this.boHelperService.serializeEndDate(value);
            }
            return value;
        });
    }
};
CompanyOrderApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CompanyOrderApiUrls)),
    __param(2, inject(Symbols.BoHelperService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyOrderApi);
export { CompanyOrderApi };
